import type { Trin } from '../types';
import { getNextTrin, trinLabel } from '../lib/curriculum';
import { useEnterAction } from '../lib/useEnterAction';

interface TrinPassedScreenProps {
  trin: Trin;
  proofAccuracy: number;
  onContinue: () => void;
}

export default function TrinPassedScreen({
  trin,
  proofAccuracy,
  onContinue,
}: TrinPassedScreenProps) {
  const next = getNextTrin(trin.id);
  useEnterAction(onContinue);

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-6 animate-fade-in-up">
      <div className="rounded-2xl bg-emerald-500/10 p-8 text-center ring-2 ring-emerald-300 dark:bg-emerald-500/15 dark:ring-emerald-500/40">
        <p className="text-5xl" aria-hidden>
          ✓
        </p>
        <h1 className="mt-3 text-3xl font-semibold text-emerald-800 dark:text-emerald-200">
          Trin bestået!
        </h1>
        <p className="mt-2 text-sm text-emerald-900/80 dark:text-emerald-100/80">
          {trinLabel(trin)} · {trin.title}
        </p>
        <p className="mt-4 font-mono text-lg text-emerald-800 dark:text-emerald-200">
          {(proofAccuracy * 100).toFixed(0)}% nøjagtighed på trin-bevis
        </p>
        {next && (
          <p className="mt-3 text-sm text-emerald-900/70 dark:text-emerald-100/70">
            Næste: {next.title}
          </p>
        )}
        <button
          type="button"
          autoFocus
          onClick={onContinue}
          className="mt-8 w-full rounded-xl bg-emerald-600 px-6 py-3 text-base font-semibold text-white shadow-sm transition hover:bg-emerald-500"
        >
          Fortsæt til opsummering
        </button>
      </div>
    </div>
  );
}
